import * as OperatorTypes from '../ObjectSegOperatorTypes';
import { __ANY_CTA } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import { tryAddMultipleRefinements } from '../multipleRefinementsUtils';
const ctaOperators = [OperatorTypes.HAS_CLICKED_CTA, OperatorTypes.HAS_NOT_CLICKED_CTA, OperatorTypes.HAS_OPENED_CTA, OperatorTypes.HAS_NOT_OPENED_CTA];
export const isNonPlacementCta = operatorName => ctaOperators.includes(operatorName);
export const fromCtaValueOperation = (Operator, field, filter) => {
  const {
    ctaName,
    operator: operatorName
  } = filter;
  const cta = isNonPlacementCta(operatorName) ? ctaName : __ANY_CTA;
  const operator = Operator.of(field, cta);
  return tryAddMultipleRefinements(operator, field, filter);
};